import LogRocket from 'logrocket';
import thunk from 'redux-thunk';
import { createStore, applyMiddleware, compose } from 'redux';
import createSagaMiddleware from 'redux-saga';
import * as Sentry from '@sentry/react';

import rootReducer from '../reducers';
import accountSaga from '../sagas/account';

export default function configureStore(initialState) {
  const sentryReduxEnhancer = Sentry.createReduxEnhancer({
    // Optionally pass further options as described here:
    // https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/redux/
  });

  const sagaMiddleware = createSagaMiddleware();

  const store = createStore(
    rootReducer,
    initialState,
    compose(applyMiddleware(sagaMiddleware, thunk, LogRocket.reduxMiddleware()), sentryReduxEnhancer)
  );

  store.sagaTask = sagaMiddleware.run(accountSaga);

  window.store = store;
  if (window.electronIPC) {
    window.electronIPC.onReduxAction((emitter, action) => store.dispatch(action));
  }

  return store;
}
